import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/modules/app/app.module';
import { initializeTelemetry } from './app/services/telemetry/faro-telemetry';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

initializeTelemetry();

platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
